import ApplicationController from '../application_controller'

class FormKvController extends ApplicationController {
  static targets = ['kvInput', 'kvDependent', 'miniJob']
  static values = {
    defaultCompanyCode: { type: String, default: '-1' }
  }

  connect () {
    this.handleChange(this.kvInputTarget)

    $(this.kvInputTarget).on('change', (e) => {
      this.handleChange(e.target)
    })
  }

  handleChange (target) {
    const value = target.value

    if (value === '6') {
      this.setDisplayAttribute('inline-flex')
      this.setDefaultMiniJob()
    } else {
      this.setDisplayAttribute('none')
    }
  }

  setDisplayAttribute (value) {
    this.kvDependentTargets.forEach(target => {
      target.style.display = value
    })
  }

  setDefaultMiniJob () {
    const selectedMiniJob = this.miniJobTarget.value
    const defaultMiniJobCompany = this.miniJobTarget.querySelector(`option[data-code="${this.defaultCompanyCodeValue}"]`)

    if (!selectedMiniJob && defaultMiniJobCompany) {
      defaultMiniJobCompany.selected = true
      this.miniJobTarget.dispatchEvent(new Event('change'))
    }
  }
}

export default FormKvController
